
import DropDownComponent from 'app/components/DropDownComponent';
import attach from 'assets/attach.svg';
import closeSvg from 'assets/close.svg';
import uploadSvg from 'assets/upload.svg';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploadFile } from 'utils/s3Helper';

import { Button, CircularProgress, LinearProgress, Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';

import {
    selectAddSuccess, selectFile, selectLoading, selectUploadUrl
} from '../../../mediaSaga/selectors';
import { actions as mediaActions } from '../../../mediaSaga/slice';
import {
    selectAddQuestion, selectAddSuccessData, selectCategories, selectCheckQuestion, selectError,
    selectQuesLoading
} from '../../selectors';
import { actions } from '../../slice';
import { useStyles } from '../../styles';

interface AddModalProps {
    openModal: boolean;
    closeAdd: () => void;
    editData?: EditData | null;
}
export interface EditData {
    id: string;
    createdAt: string;      // ISO date string
    body: string;
    date: string;           // formatted date "dd/MM/yyyy"
    status: boolean;
    name: string;           // this is the "question" text
    video_length: string;
    video: string;          // mp4 url
    playList: string;       // m3u8 url
    processStatus: "SUCCESS" | "PENDING" | "FAILED"; // if limited states
    category: string;       // category name
    category_id: string;
}



function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

export const AddModal = ({ openModal, closeAdd, editData = null }: AddModalProps) => {
    const dispatch = useDispatch();
    const err = useSelector(selectError);
    const uploadUrl = useSelector(selectUploadUrl)
    const addSuccessData = useSelector(selectAddSuccessData);
    const addSuccessDataMedia = useSelector(selectAddSuccess);
    const selectedFile: any = useSelector(selectFile);
    const addQuestion = useSelector(selectAddQuestion);
    const checkQuestion = useSelector(selectCheckQuestion);
    const loading = useSelector(selectLoading)
    const quesloading = useSelector(selectQuesLoading)

    const categories = useSelector(selectCategories);
    const styles = useStyles();

    const { category_id, question, body } = addQuestion;
    const [pressed, setPressed] = useState(false)
    const [startUplaoding, setStartUploading] = useState(false)
    const [showError, setShowError] = useState(false)
    const setCategory = e => {
        setPressed(false)
        dispatch(actions.getAddedCategoryId(e));
    };
    const validQuestion = (question) => {
        if (!question?.trim()) {
            return 'Question cannot be empty'
        }
        if (question?.length > 100) {
            return 'Question limit 100 characters'
        }
        return null
    }
    const validBody = (body) => {
        if (!body?.trim()) {
            return 'Body cannot be empty'
        }
        if (body?.length > 256) {
            return 'Body limit 256 characters'
        }
        return null
    }
    const validFile = (file) => {
        if (!file) {
            return 'Please select a video'
        }
        if (file.type.search("mp4") == -1) {
            return 'Please select a mp4 video file'
        }
        if (file.size / 1024000 > 100) {
            return 'Please select less than 100mb'
        }
        return null
    }
    const validCategory = (category) => {
        if (!category?.trim()) {
            return 'select a category'
        }
        return null
    }
    const validExist = (err) => {
        if (err === 'MESSAGE_QUESTION_EXIST') {
            return 'Question already exist'
        }
        return null
    }
    const checkUploading = (err) => {
        if (startUplaoding === true) {
            return 'Video is in progress can not cancel'
        }
        return null
    }

    const [inputRef, setInputRef] = useState<HTMLInputElement | null>()
    const handleChoose = () => {
        inputRef?.click()
        // inputRef.current.click()
    }
    const handleFileChange = (event) => {
        dispatch(mediaActions.setFile({
            file: {
                name: event.target.files[0].name,
                type: event.target.files[0].type,
                size: event.target.files[0].size,
                url: URL.createObjectURL(event.target.files[0])
            }
        }))
        dispatch(mediaActions.getUploadUrl({ fileName: event.target.files[0].name, contentType: event.target.files[0].type }));
    }
    const setQuestion = e => {
        setPressed(false)
        dispatch(actions.getAddedQuestion(e.nativeEvent.target.value));
    };
    const setBody = e => {
        setPressed(false)
        dispatch(actions.getAddedBody(e.nativeEvent.target.value));
    };
    const handleAddSubmit = () => {
        setPressed(true);
        if (editData) {
            if (!validQuestion(question) && !validBody(body) && !validCategory(category_id) && !validFile(selectedFile)) {
                dispatch(actions.getUpdateQuestion({ id: editData.id, video: uploadUrl?.mediaKey, callback: closeAdd }));
                setStartUploading(true);
            }

        } else {
            if (!validQuestion(question) && !validBody(body) && !validCategory(category_id) && !validFile(selectedFile)) {
                dispatch(actions.checkQuestions({ question: question }))
            }
        }

    };

    useEffect(() => {
        if (checkQuestion == "Success") {

            dispatch(actions.getAddQuestion(uploadUrl.mediaKey));
            setStartUploading(true);


        } else {
            dispatch(mediaActions.stopLoading());
        }
        dispatch(actions.clearCheckQuestion());
    }, [checkQuestion])

    useEffect(() => {
        if (editData) {
            // map parent fields into your redux state
            dispatch(actions.getAddedCategoryId(editData.category_id)); // just category name for now
            dispatch(actions.getAddedQuestion(editData.name));       // parent calls it "name"
            dispatch(actions.getAddedBody(editData.body));

            // prefill video if exists
            if (editData.video) {
                dispatch(mediaActions.setFile({
                    file: {
                        name: editData.name + ".mp4",
                        type: "video/mp4",
                        size: 0, // unknown, since it's already uploaded
                        url: editData.video,
                    }
                }));

                dispatch(actions.getAddedVideoLength(editData.video_length));
            }
        }
    }, [editData, dispatch]);


    const [fileProgress, setFileProgress] = useState<any>(0)
    const onProgress = (fileName: any, data: any) => {
        if (data !== 'start' && data !== "end") {
            setFileProgress(data)
        }
        if (data == "end") {
            var video: any = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = function () {
                window.URL.revokeObjectURL(video.src);
                // var duration = video.duration;
                const dur = Math.floor(parseInt(video.duration, 10));
                const duration = `${moment.duration(dur, 'seconds').minutes()} min ${moment
                    .duration(dur, 'seconds')
                    .seconds()} sec `;

                dispatch(actions.getAddedVideoLength(duration));
                dispatch(mediaActions.getUploadTranscoder({ fileName: uploadUrl?.mediaKey }))
                // dispatch(actions.getAddQuestion());
            };
            video.src = selectedFile.url;

        }
    }

    const uploadFilesToS3 = async () => {
        dispatch(mediaActions.startLoading());
        setFileProgress(0)
        uploadFile(selectedFile, uploadUrl.mediaUrl, onProgress);
    }

    useEffect(() => {
        if (uploadUrl && uploadUrl.mediaUrl) {
            uploadFilesToS3();
        }
    }, [uploadUrl])


    useEffect(() => {
        if (err === 'MESSAGE_QUESTION_CREATED') {
            let data = {
                userId: addSuccessData.id,
                title: selectedFile?.name,
                thumbnail: uploadUrl.mediaThumbnailKey,
                size: selectedFile?.size,
                file_type: "VIDEO",
                media_type: "QUESTIONS",
                url: uploadUrl.mediaKey,
            }
            dispatch(mediaActions.setForm(data));
            dispatch(mediaActions.addMedia())
        }
    }, [err]);

    useEffect(() => {
        if (addSuccessDataMedia) {
            setStartUploading(false);
            closeAdd()
            dispatch(mediaActions.clearAddData())
            dispatch(mediaActions.clearUploadUrl())
            dispatch(actions.clearAddData())
            // dispatch(actions.getQuestion());

        }
    }, [addSuccessDataMedia]);

    useEffect(() => {
        return () => {
            dispatch(mediaActions.clearAddData())
            dispatch(mediaActions.clearUploadUrl())
            dispatch(actions.clearAddData())
            // dispatch(actions.getQuestion());
            dispatch(actions.setAddQuestionLoading(false));
        }
    }, [])

    return (
        <Modal
            open={openModal}
            onClose={closeAdd}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '35rem',
                    bgcolor: 'background.paper',
                    boxShadow: 10,
                    p: 3,
                    borderRadius: 2,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flex: 1,
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography sx={{ fontSize: 16, fontWeight: '900' }}>
                        {editData ? 'Edit Question' : 'Add New Question'}
                    </Typography>
                    <img
                        src={closeSvg}
                        alt="closeSvg"
                        onClick={closeAdd}
                        className={styles.closeSvg}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'start',
                        alignItems: 'center',
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: '1.5rem' }} >
                        <div>
                            <DropDownComponent
                                array={categories}
                                isCategory={false}
                                setUser={setCategory}
                                user={category_id}
                                widthNo="13rem"
                                label={'Category'}
                            />
                        </div>
                        {pressed && validCategory(category_id) && <Typography sx={{ color: '#911', marginTop: 1, position: 'absolute', top: '85px' }}>{validCategory(category_id)}</Typography>}
                    </div>
                    <input
                        ref={el => setInputRef(el)}
                        type="file"
                        style={{
                            display: 'none'
                        }}
                        className="VideoInput_input"
                        onChange={handleFileChange}
                        accept=".mov,.mp4"
                    />
                    <div style={{ marginTop: '1.5rem' }}>
                        {selectedFile ? <Button onClick={handleChoose}
                            sx={{
                                padding: '10px 15px',
                                cursor: 'auto',
                                borderRadius: '4px',
                                marginLeft: 2,
                                maxHeight: 40,
                                border: '0.5px solid'
                            }}>
                            <img src={attach} alt="Attach File" className={styles.attach} />
                            <Typography sx={{ fontSize: 13, fontWeight: '400', textAlign: 'center', textOverflow: 'ellipsis', overflow: 'hidden', minHeight: '21px', whiteSpace: 'nowrap', width: '135px' }}>
                                {selectedFile.name}
                            </Typography></Button> : <Button
                                variant="outlined"
                                onClick={handleChoose}
                                sx={{
                                    color: '#fff',
                                    backgroundColor: '#12BFE0',
                                    '&:hover': {
                                        backgroundColor: '#12bfe0',
                                    },
                                    fontSize: '0.875rem',
                                    padding: '5px 15px',
                                    fontWeight: '500',
                                    cursor: 'auto',
                                    borderRadius: '4px',
                                    marginLeft: 2,
                                }}
                            >
                            <img src={uploadSvg} alt="uploadSvg" className={styles.upload} />
                            <Typography sx={{ fontSize: 19, fontWeight: '400' }}>
                                {'Upload Video'}
                            </Typography>
                        </Button>}
                        {pressed && validFile(selectedFile) && <Typography sx={{ color: '#911', marginTop: 1, marginLeft: '16px', position: 'absolute' }}>{validFile(selectedFile)}</Typography>}
                    </div>
                </div>
                {
                    loading
                        ?
                        <Box sx={{ width: '100%' }}>
                            <LinearProgressWithLabel value={fileProgress} />
                        </Box>
                        :
                        ''
                }

                <div
                    style={{
                        margin: '1.5rem 0rem 0rem 0rem',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: '#6C7389',
                                    fontWeight: 'normal',
                                    marginBottom: 1,
                                }}
                            >
                                Question
                            </Typography>
                            <input
                                onChange={setQuestion}
                                value={question}
                                className={styles.titleInput}
                            />
                            {pressed && validQuestion(question) && <Typography sx={{ color: '#911', marginTop: 1 }}>{validQuestion(question)}</Typography>}

                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                marginTop: '1.5rem',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: '#6C7389',
                                    fontWeight: 'normal',
                                    marginBottom: 1,
                                }}
                            >
                                Body
                            </Typography>
                            <textarea
                                onChange={setBody}
                                value={body}
                                className={styles.textArea}
                            />
                            {pressed && validBody(body) && <Typography sx={{ color: '#911', marginTop: 1 }}>{validBody(body)}</Typography>}
                            {validExist(err) && <Typography sx={{ color: '#911', marginTop: 1 }}>{validExist(err)}</Typography>}
                            {showError && checkUploading(err) && <Typography sx={{ color: '#911', marginTop: 1 }}>{checkUploading(err)}</Typography>}
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            margin: '1rem 0rem 0rem 0rem',
                        }}
                    >
                        <Button
                            variant="outlined"
                            sx={{
                                color: '#6C7389',
                                backgroundColor: '#E7E7E7',
                                borderColor: '#e7e7e7',
                                '&:hover': {
                                    borderColor: '#e7e7e7',
                                    backgroundColor: '#E7E7E7',
                                },
                                fontSize: '0.75rem',
                                fontWeight: '500',
                                cursor: 'auto',
                                borderRadius: '5px',
                                marginLeft: 2,
                            }}
                            onClick={() => {
                                setShowError(true);
                                if (!startUplaoding) {
                                    closeAdd()
                                }
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleAddSubmit}
                            variant="outlined"
                            sx={{
                                color: '#fff',
                                backgroundColor: '#12BFE0',
                                '&:hover': {
                                    backgroundColor: '#12bfe0',
                                },
                                fontSize: '0.75rem',
                                padding: '6px 30px',
                                fontWeight: '500',
                                cursor: 'auto',
                                borderRadius: '5px',
                                marginLeft: 2,
                            }}
                            disabled={quesloading || !(addQuestion?.videoLength != '' || addQuestion?.videoLength)}
                        >
                            {quesloading ? <CircularProgress style={{
                                width: "25px",
                                height: "25px",
                                position: "absolute",
                                color: "#fff"
                            }} /> : ''}
                            {editData ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};